import {
  ExploreMoreRoot,
  Features,
  Feature,
  LearnMoreCard,
  CopyColumn,
  LearnMoreButton,
  ImageCopy,
  ExploreMoreSlider,
  ImageWrapper,
} from './ExploreMore.styles'
import { Title } from './ExploreMore.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { TranslationKeys } from 'locales/translationKeys'
import Image from 'next/image'
import Link from 'next/link'
import { Proteins } from 'models/Pet'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { sliderSettings } from 'fixtures/slider'
import SliderArrow from 'features/components/ReviewSlider/SliderArrow'
import { frozenProducts } from 'features/Recipes/Overview/components/SelectRecipes/products'

type ExploreMoreProps = {
  recipe: Proteins
}

export const ExploreMore = ({ recipe }: ExploreMoreProps) => {
  const { t } = useTranslation()

  const sliderSettingsRecipes = {
    ...sliderSettings,
    dots: true,
    arrows: true,
    nextArrow: <SliderArrow color="primary-500" right />,
    prevArrow: <SliderArrow color="primary-500" />,
    slidesToShow: 3,
    slidesToScroll: 2,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  }

  return (
    <ExploreMoreRoot>
      <Title size="h1" align="center">
        {t('recipes:frozen-v2.explore.title')}
      </Title>
      <Features>
        {Array.from({ length: 4 }).map((_, index) => (
          <Feature alignItems="center" key={index}>
            <Icon size="4" name="checkbox-circle-line" color="primary-500" />
            <Text size="caption">
              {t(`recipes:frozen-v2.explore.features.${index}` as TranslationKeys)}
            </Text>
          </Feature>
        ))}
      </Features>

      <ExploreMoreSlider>
        <Slider {...sliderSettingsRecipes}>
          {frozenProducts
            .filter((product) => product.protein !== recipe)
            .map((product) => (
              <LearnMoreCard key={product.protein}>
                <ImageCopy>
                  <ImageWrapper>
                    <Image
                    layout='fill'
                      src={product.image}
                      alt={product.imageAlt}
                    />
                  </ImageWrapper>
                  <CopyColumn>
                    <Text
                      align={{ '@initial': 'center', '@bp2': 'left' }}
                      font="display"
                      size={{ '@initial': 'h5', '@bp2': 'h3' }}
                    >
                      {t(product.name as TranslationKeys)}
                    </Text>
                    <Text align={{ '@initial': 'center', '@bp2': 'left' }} size="caption">
                      {t(product.description as TranslationKeys)}
                    </Text>
                  </CopyColumn>
                </ImageCopy>
                <Link passHref href={`/recipes/${product.link}`}>
                  <LearnMoreButton variant="secondaryAlt">
                    {t('recipes:frozen-v2.explore.cta')}
                  </LearnMoreButton>
                </Link>
              </LearnMoreCard>
            ))}
        </Slider>
      </ExploreMoreSlider>
    </ExploreMoreRoot>
  )
}

ExploreMore.displayName = 'Explore More'
